import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
  container: {
    maxWidth: 1100,
    margin: '0 auto',
  },
  compositionCell: {
    padding: '4px 0 0 0',
  },
  compositionIcon: {
    cursor: 'pointer',
  },
  paginationSelect: {
    '& .input-size-small.MuiSelect-select': { padding: '8px 50px 8px 12px' },
    '& .MuiSelect-icon': { right: '0px' },
  },
}));

export default useStyles;
